import React from "react";

import { Link } from "react-router-dom";

class Listado extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    render() {
        return (
            <>
                <section className="content-header">
                    <h1> Asistente para la migración de datos</h1>
                </section>

                <section className="content container-fluid">
                    <div className="row">
                        <div className="col-lg-6">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <b className="text-primary">1 - BARRILES</b>
                                </li>
                                <li className="list-group-item">
                                    <ul>
                                        <li>Carga inicial de tus barriles</li>
                                    </ul>
                                </li>
                                <li className="list-group-item">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <ul className="list-inline pull-right">
                                                <li className="">
                                                    <Link
                                                        to="/secure/config/migracion/barriles"
                                                        className="text-primary"
                                                    >
                                                        COMENZAR <i className="fa fa-arrow-right margin-r-5"></i>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <b className="text-primary">2 - PRODUCTOS</b>
                                </li>
                                <li className="list-group-item">
                                    <ul>
                                        <li>Carga rápida de tus cervezas y un precio de referencia.</li>
                                    </ul>
                                </li>
                                <li className="list-group-item">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <ul className="list-inline pull-right">
                                                <li className="">
                                                    <a
                                                        href="/secure/config/instalador/productos/?back_url=/secure/config/instalador/"
                                                        className="text-primary"
                                                    >
                                                        COMENZAR <i className="fa fa-arrow-right margin-r-5"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <b className="text-primary">3 - CLIENTES</b>
                                </li>
                                <li className="list-group-item">
                                    <ul>
                                        <li>Carga rápida de tus clientes</li>
                                        <li>Carga de la deuda actual del cliente</li>
                                    </ul>
                                </li>
                                <li className="list-group-item">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <ul className="list-inline pull-right">
                                                <li className="">
                                                    <a
                                                        href="/secure/config/instalador/clientes/?back_url=/secure/config/instalador/"
                                                        className="link-blac text-primary"
                                                    >
                                                        COMENZAR <i className="fa fa-arrow-right margin-r-5"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <b className="text-primary">4 - CARGA DE PRODUCTOS EN BARRILES</b>
                                </li>
                                <li className="list-group-item">
                                    <ul>
                                        <li>Carga rápida: ¿que contienen tus barriles?</li>
                                        <li>Producto por producto iras llenando los barriles</li>
                                    </ul>
                                </li>
                                <li className="list-group-item">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <ul className="list-inline pull-right">
                                                <li className="">
                                                    <a
                                                        href="/secure/config/instalador/embarrilar/1?back_url=/secure/config/instalador/"
                                                        className="link-blac text-primary"
                                                    >
                                                        COMENZAR <i className="fa fa-arrow-right margin-r-5"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-6">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <b className="text-primary">5 - ENTREGA DE BARRILES EN CLIENTES</b>
                                </li>
                                <li className="list-group-item">
                                    <ul>
                                        <li>Carga rápida: ¿quien tiene tus barriles?</li>
                                        <li>Cliente por cliente iras entregando los barriles</li>
                                    </ul>
                                </li>
                                <li className="list-group-item">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <ul className="list-inline pull-right">
                                                <li className="">
                                                    <a
                                                        href="/secure/config/instalador/entregar/1?back_url=/secure/config/instalador/"
                                                        className="text-primmary "
                                                    >
                                                        COMENZAR <i className="fa fa-arrow-right margin-r-5"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-6">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <b className="text-primary">6 - PROVEEDORES</b>
                                </li>
                                <li className="list-group-item">
                                    <ul>
                                        <li>Carga rápida de tus proveedores</li>
                                        <li>Carga de la deuda actual del proveedor</li>
                                    </ul>
                                </li>
                                <li className="list-group-item">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <ul className="list-inline pull-right">
                                                <li className="">
                                                    <a
                                                        href="/secure/config/instalador/proveedores/?back_url=/secure/config/instalador/"
                                                        className="link-blac text-primary"
                                                    >
                                                        COMENZAR <i className="fa fa-arrow-right margin-r-5"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-6">
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <b className="text-red">99 - BORRAR DATOS (Proximamente)</b>
                                </li>
                                <li className="list-group-item">
                                    <ul>
                                        <li>¿Estuviste probando y necesitas empezar de cero?</li>
                                    </ul>
                                </li>
                                <li className="list-group-item">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <ul className="list-inline pull-right">
                                                <li className="">
                                                    <a href="javascript:void(0);" className="text-red ">
                                                        SOLICITAR X MAIL O WHATSAPP
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

export default Listado;
